import classNames from "classnames";
import { connect } from "react-redux";
import getConfig from "next/config";

import Alert from "@components/Alert";
import useToasts from "@components/PromoToasts/useToasts";
import { setPromoToastVisible } from "@store/app/actions";
import { cookieClientStore } from "@lib/clientStore";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const PromoToasts = ({
  type,
  params,
  user,
  setPromoToastVisible,
  userDismissedNewsletter,
}) => {
  const { toast, setToastRead } = useToasts({
    type,
    params,
    userInitial: user.isInitial,
    setPromoToastVisible,
  });

  if (!toast) {
    return null;
  }

  // TODO add a way to update redux state for the user to dismiss the newsletter popup
  const isCookieConsentPopupVisible = Boolean(
    !cookieClientStore.get("CookieConsent")
  );
  const isNewsletterPopupVisible = !userDismissedNewsletter;

  const positionClasses = classNames(
    "fixed z-10 right-0 sm:right-[15px] max-w-[420px] min-w-[320px] space-y-2",
    {
      // all are visible
      "bottom-0 sm:bottom-[100px] xl:bottom-[290px]":
        isNewsletterPopupVisible && isCookieConsentPopupVisible,
      // only cookies are visible
      "bottom-2 xl:bottom-[200px]":
        !isNewsletterPopupVisible && isCookieConsentPopupVisible,
      // only newsletter is visible
      "bottom-0 sm:bottom-[100px] xl:bottom-[100px]":
        isNewsletterPopupVisible && !isCookieConsentPopupVisible,
      // none are visible
      "bottom-0 sm:bottom-[8px]":
        !isNewsletterPopupVisible && !isCookieConsentPopupVisible,
    }
  );

  return (
    <div className={positionClasses}>
      {toast && (
        <Alert
          type="blank"
          hasShadow={true}
          onClose={() => setToastRead(toast.id)}
          showIcon={!!toast?.image}
          image={{
            src: `${settings.cdn}/media/label/image${toast?.image}`,
            alt: toast.title,
          }}
        >
          <div className="text-sm mr-[8px]">
            <h3 className="text-red-brand font-medium">{toast.title}</h3>
            {toast?.coupon_code && (
              <p>
                Cod:{" "}
                <strong className="font-medium">{toast.coupon_code}</strong>
              </p>
            )}
            <p>{toast.description}</p>
            {toast?.url_link && (
              <div>
                <a className="text-[#0F62FE] underline" href={toast.url_link}>
                  {toast.url_text || "Detalii"}
                </a>
              </div>
            )}
          </div>
        </Alert>
      )}
    </div>
  );
};

export default connect(
  (state) => ({
    user: state.user,
    userDismissedNewsletter: state.app.userDismissedNewsletter,
  }),
  { setPromoToastVisible }
)(PromoToasts);
